export class FluidResizeObserver {
  _host: any;
  _entryCallback: Function;
  _observer: ResizeObserver;

  _width: number;
  _height: number;

  constructor(host, entryCallback) {
    this._host = host;
    this._entryCallback = entryCallback;

    this._observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const { width, height } = entry.contentRect;
        if (typeof width === 'number' && typeof height === 'number') {
          if (this.hasChanged(width, this._width)) {
            this._width = width;
          }
          if (this.hasChanged(height, this._height)) {
            this._height = height;
          }
          this._entryCallback(this._width, this._height);
        }
      });
    });
  }

  hasChanged(prop, old) {
    return old !== prop;
  }

  observe() {
    this._observer.observe(this._host, { box: 'border-box' });
  }

  unobserve() {
    this._observer.unobserve(this._host);
  }
}
